import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'spinner-component',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class SpinnerComponent implements OnInit {
  @Input() message: string = 'Cargando...';
  @Input() imagen_src: string = '/assets/images/logo/JEDSTION_rayo_lima.svg'
  @Input() isFixed: boolean = true;
  constructor() { }

  ngOnInit(): void { }
}
